// src/modules/talent/dashboard/widgets/shells/FunnelByStageChart.tsx
import { useQuery } from "@tanstack/react-query";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { GitBranch } from "lucide-react";
import { apiFetch } from "@/modules/shared/lib/api-client";
import { PIPELINE_STAGES } from "@/modules/talent/hooks/useATSPipeline";

type Funnel = { stages: { stage: string; count: number }[] };

const STAGE_LABEL: Record<string, string> = Object.fromEntries(
  PIPELINE_STAGES.map((s) => [s.key, s.label])
);

const KNOWN_STAGES = new Set(PIPELINE_STAGES.map((s) => s.key));

export function FunnelByStageChart() {
  const { data } = useQuery<Funnel>({
    queryKey: ["widget", "/talent/dashboard/funnel"],
    queryFn: () => apiFetch<Funnel>("/talent/dashboard/funnel"),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });

  const chartData = (data?.stages ?? [])
    .filter((s) => KNOWN_STAGES.has(s.stage))
    .map((s) => ({
      ...s,
      label: STAGE_LABEL[s.stage] ?? s.stage,
    }));

  return (
    <div className="ol-card flat col-span-2 flex flex-col gap-3">
      <div className="ol-card-head">
        <div className="ol-card-ic ink"><GitBranch /></div>
        <div className="ol-card-title">
          <div className="ol-card-name"><span className="n">Funil por etapa</span></div>
        </div>
      </div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fill: "#6b716b", fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fill: "#6b716b", fontSize: 11 }} />
            <Tooltip />
            <Bar dataKey="count" fill="#c6f04c" stroke="#0b0d0b" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
